import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Row, Col, Card, Button, Space, Tag } from 'antd';
import {
    CarOutlined,
    HomeOutlined,
    MedicineBoxOutlined,
    ToolOutlined,
    SafetyOutlined,
    RocketOutlined,
    AuditOutlined,
    BugOutlined,
    CheckCircleOutlined,
    ArrowRightOutlined,
    PhoneOutlined,
    StarFilled,
    ThunderboltOutlined,
    TeamOutlined,
    TrophyOutlined,
    ClockCircleOutlined,
    DollarOutlined,
    HeartOutlined,
    SafetyCertificateOutlined,
    CustomerServiceOutlined,
    FileProtectOutlined,
    WhatsAppOutlined,
} from '@ant-design/icons';
import './Assurances.scss';

const { Title, Paragraph, Text } = Typography;

const assurancesData = {
    auto: {
        icon: <CarOutlined />,
        title: 'Assurance Automobile',
        category: 'IARD',
        color: '#1A2B5F',
        description: 'L\'assurance automobile est obligatoire en Cote d\'Ivoire. CAP Assurances vous propose les meilleures formules adaptees a votre vehicule et a votre budget.',
        accroche: 'Roulez l\'esprit tranquille, on s\'occupe du reste.',
        garanties: [
            'Responsabilite Civile (obligatoire)',
            'Dommages collision',
            'Vol et tentative de vol',
            'Incendie et explosion',
            'Bris de glace',
            'Assistance 24h/24',
            'Defense et recours',
            'Garantie conducteur',
        ],
        formules: [
            { nom: 'Tiers', desc: 'Couverture minimale obligatoire', tag: 'Essentiel', prix: 'A partir de 50 000 FCFA' },
            { nom: 'Tiers Etendu', desc: 'Tiers + vol + incendie + bris de glace', tag: 'Recommande', prix: 'A partir de 85 000 FCFA' },
            { nom: 'Tous Risques', desc: 'Couverture complete de votre vehicule', tag: 'Premium', prix: 'Sur devis personnalise' },
        ],
        avantages: [
            { icon: <ClockCircleOutlined />, titre: 'Attestation en 24h', desc: 'Recevez votre attestation d\'assurance en moins de 24 heures' },
            { icon: <DollarOutlined />, titre: 'Paiement flexible', desc: 'Payez en plusieurs fois sans frais supplementaires' },
            { icon: <CustomerServiceOutlined />, titre: 'Assistance 24h/24', desc: 'Un depanneur intervient partout en Cote d\'Ivoire' },
            { icon: <SafetyCertificateOutlined />, titre: 'Multi-compagnies', desc: 'On compare 8+ assureurs pour vous trouver le meilleur tarif' },
        ],
        faq: [
            { q: 'Quels documents pour assurer mon vehicule ?', r: 'Carte grise, permis de conduire, piece d\'identite et ancienne attestation si disponible.' },
            { q: 'Puis-je payer en plusieurs fois ?', r: 'Oui, CAP Assurances propose un echelonnement en 2, 3 ou 4 versements sans frais supplementaires.' },
            { q: 'Combien de temps pour obtenir mon attestation ?', r: 'Votre attestation est delivree sous 24 heures apres validation du paiement.' },
        ],
        temoignage: { nom: 'Kouame A.', ville: 'Abidjan', texte: 'J\'ai compare plusieurs offres et CAP Assurances m\'a propose la meilleure couverture au meilleur prix. L\'attestation a ete livree le jour meme !' },
    },
    habitation: {
        icon: <HomeOutlined />,
        title: 'Assurance Habitation',
        category: 'IARD',
        color: '#C8102E',
        description: 'Protegez votre domicile et vos biens contre les sinistres. Notre assurance habitation couvre les risques les plus courants et vous offre une tranquillite d\'esprit.',
        accroche: 'Votre maison merite la meilleure protection.',
        garanties: [
            'Incendie et explosion',
            'Degat des eaux',
            'Vol et vandalisme',
            'Catastrophes naturelles',
            'Responsabilite civile habitation',
            'Bris de glace',
            'Dommages electriques',
            'Relogement temporaire',
        ],
        formules: [
            { nom: 'Locataire', desc: 'Protection pour les locataires', tag: 'Essentiel', prix: 'A partir de 35 000 FCFA/an' },
            { nom: 'Proprietaire', desc: 'Protection complete du bien et du contenu', tag: 'Recommande', prix: 'A partir de 65 000 FCFA/an' },
            { nom: 'Multirisque', desc: 'Couverture etendue tous risques', tag: 'Premium', prix: 'Sur devis personnalise' },
        ],
        avantages: [
            { icon: <ClockCircleOutlined />, titre: 'Souscription rapide', desc: 'Assurez votre logement en moins de 30 minutes' },
            { icon: <DollarOutlined />, titre: 'Tarifs competitifs', desc: 'Nous comparons les offres de 8+ compagnies pour vous' },
            { icon: <FileProtectOutlined />, titre: 'Indemnisation rapide', desc: 'Prise en charge de votre sinistre sous 48h' },
            { icon: <SafetyCertificateOutlined />, titre: 'Couverture sur mesure', desc: 'Une formule adaptee a votre bien et votre budget' },
        ],
        faq: [
            { q: 'L\'assurance habitation est-elle obligatoire ?', r: 'Elle est fortement recommandee et souvent exigee par les bailleurs pour les locataires.' },
            { q: 'Que couvre l\'assurance multirisque habitation ?', r: 'Elle couvre votre logement, vos biens, votre responsabilite civile et offre un relogement temporaire en cas de sinistre.' },
            { q: 'Comment declarer un sinistre ?', r: 'Contactez-nous par telephone ou depuis votre espace client. Nous prenons en charge votre dossier sous 48h.' },
        ],
        temoignage: { nom: 'Marie K.', ville: 'Cocody', texte: 'Apres un degat des eaux, CAP Assurances m\'a relogee en 24h et mon dossier a ete traite en une semaine. Un service exceptionnel !' },
    },
    sante: {
        icon: <MedicineBoxOutlined />,
        title: 'Assurance Sante',
        category: 'IARD',
        color: '#2e7d32',
        description: 'La sante est notre bien le plus precieux. CAP Assurances vous propose des solutions de couverture sante adaptees, pour vous et votre famille.',
        accroche: 'Prenez soin de vous, on prend soin de vos frais.',
        garanties: [
            'Hospitalisation et chirurgie',
            'Consultations medicales',
            'Pharmacie et medicaments',
            'Analyses et examens',
            'Soins dentaires',
            'Optique',
            'Maternite',
            'Evacuation sanitaire',
        ],
        formules: [
            { nom: 'Individuel', desc: 'Couverture sante individuelle', tag: 'Essentiel', prix: 'A partir de 15 000 FCFA/mois' },
            { nom: 'Famille', desc: 'Protection pour toute la famille', tag: 'Recommande', prix: 'A partir de 35 000 FCFA/mois' },
            { nom: 'Entreprise', desc: 'Couverture sante pour vos employes', tag: 'Entreprise', prix: 'Sur devis personnalise' },
        ],
        avantages: [
            { icon: <HeartOutlined />, titre: 'Reseau medical etendu', desc: 'Acces a 200+ cliniques et pharmacies partenaires en Cote d\'Ivoire' },
            { icon: <ThunderboltOutlined />, titre: 'Prise en charge directe', desc: 'Pas d\'avance de frais dans notre reseau de soins' },
            { icon: <TeamOutlined />, titre: 'Toute la famille couverte', desc: 'Conjoint et enfants inclus dans la formule Famille' },
            { icon: <CustomerServiceOutlined />, titre: 'Assistance medicale 24h/24', desc: 'Un medecin conseil joignable a tout moment' },
        ],
        faq: [
            { q: 'Y a-t-il un delai de carence ?', r: 'Selon la formule choisie, le delai de carence varie de 0 a 3 mois. Nos conseillers vous guident dans le choix le plus adapte.' },
            { q: 'La maternite est-elle couverte ?', r: 'Oui, les formules Famille et Entreprise incluent la maternite avec suivi prenatal, accouchement et soins postnataux.' },
            { q: 'Puis-je choisir mon medecin ?', r: 'Oui, vous pouvez consulter dans notre reseau pour une prise en charge directe ou chez tout medecin avec remboursement.' },
        ],
        temoignage: { nom: 'Dr. Traore B.', ville: 'Plateau', texte: 'J\'ai assure tous mes employes chez CAP Assurances. La prise en charge directe en clinique et le suivi personnalise font toute la difference.' },
    },
    chantier: {
        icon: <ToolOutlined />,
        title: 'Assurance Chantier',
        category: 'IARD',
        color: '#e65100',
        description: 'L\'assurance chantier protege vos travaux de construction contre les dommages materiels, les accidents et les responsabilites civiles liees au chantier.',
        accroche: 'Construisez sereinement, on protege votre chantier.',
        garanties: [
            'Tous risques chantier (TRC)',
            'Responsabilite civile decennale',
            'Dommages aux ouvrages',
            'Responsabilite civile maitre d\'ouvrage',
            'Bris de materiel',
            'Accidents du travail',
            'Protection juridique',
            'Pertes d\'exploitation',
        ],
        formules: [
            { nom: 'Standard', desc: 'Couverture de base pour petits chantiers', tag: 'Essentiel', prix: 'A partir de 150 000 FCFA' },
            { nom: 'Complete', desc: 'Protection etendue pour chantiers importants', tag: 'Recommande', prix: 'Sur devis personnalise' },
        ],
        avantages: [
            { icon: <SafetyCertificateOutlined />, titre: 'Protection globale', desc: 'Ouvrage, materiel et personnel couverts sur un seul contrat' },
            { icon: <FileProtectOutlined />, titre: 'Conformite garantie', desc: 'Respect des obligations legales pour tous types de chantiers' },
            { icon: <ThunderboltOutlined />, titre: 'Devis sous 48h', desc: 'Evaluation rapide de vos besoins par nos experts BTP' },
            { icon: <DollarOutlined />, titre: 'Tarifs negocies', desc: 'Nos partenariats avec les assureurs vous garantissent le meilleur prix' },
        ],
        faq: [
            { q: 'L\'assurance TRC est-elle obligatoire ?', r: 'Oui, elle est obligatoire pour les constructions neuves et les gros travaux de renovation en Cote d\'Ivoire.' },
            { q: 'Que couvre la garantie decennale ?', r: 'Elle couvre les malfacons et defauts de construction pendant 10 ans apres la reception des travaux.' },
            { q: 'Mon personnel est-il couvert ?', r: 'Oui, la formule Complete inclut les accidents du travail pour tous les intervenants sur le chantier.' },
        ],
        temoignage: { nom: 'Kone D.', ville: 'Marcory', texte: 'Pour notre immeuble de 12 etages, CAP Assurances a su nous proposer une couverture complete a un prix tres competitif. Un vrai partenaire.' },
    },
    transport: {
        icon: <RocketOutlined />,
        title: 'Assurance Transport',
        category: 'IARD',
        color: '#4a148c',
        description: 'Protegez vos marchandises pendant leur acheminement. L\'assurance transport couvre les pertes et dommages subis par vos biens en transit.',
        accroche: 'Vos marchandises arrivent a bon port, garanties.',
        garanties: [
            'Tous risques transport',
            'Avaries particulieres',
            'Perte totale',
            'Mouille et contamination',
            'Vol et disparition',
            'Retard de livraison',
            'Responsabilite du transporteur',
            'Stockage intermediaire',
        ],
        formules: [
            { nom: 'FAP', desc: 'Franc d\'avaries particulieres', tag: 'Essentiel', prix: 'A partir de 0.3% de la valeur' },
            { nom: 'Tous Risques', desc: 'Couverture complete des marchandises', tag: 'Recommande', prix: 'A partir de 0.5% de la valeur' },
        ],
        avantages: [
            { icon: <SafetyCertificateOutlined />, titre: 'Tous modes de transport', desc: 'Route, mer, air - vos marchandises sont couvertes partout' },
            { icon: <ClockCircleOutlined />, titre: 'Certificat immediat', desc: 'Votre certificat d\'assurance delivre en quelques heures' },
            { icon: <DollarOutlined />, titre: 'Indemnisation rapide', desc: 'Traitement de votre sinistre sous 72h ouvrees' },
            { icon: <CustomerServiceOutlined />, titre: 'Expertise dediee', desc: 'Une equipe specialisee en commerce international' },
        ],
        faq: [
            { q: 'Quels types de marchandises sont couverts ?', r: 'Toutes les marchandises : produits alimentaires, matieres premieres, equipements industriels, biens de consommation, etc.' },
            { q: 'Le stockage intermediaire est-il couvert ?', r: 'Oui, la formule Tous Risques couvre vos marchandises meme pendant les periodes de stockage en transit.' },
            { q: 'Comment est calculee la prime ?', r: 'La prime est basee sur un pourcentage de la valeur declaree des marchandises, selon le type et le trajet.' },
        ],
        temoignage: { nom: 'Ouattara S.', ville: 'Treichville', texte: 'En tant qu\'importateur, j\'avais besoin d\'un partenaire fiable. CAP Assurances a indemnise ma cargaison endommagee en 5 jours. Impressionnant.' },
    },
    'responsabilite-civile': {
        icon: <AuditOutlined />,
        title: 'Responsabilite Civile',
        category: 'IARD',
        color: '#37474f',
        description: 'La RC professionnelle protege votre entreprise contre les dommages causes a des tiers dans le cadre de votre activite professionnelle.',
        accroche: 'Exercez votre metier sans craindre les imprevisibles.',
        garanties: [
            'RC Professionnelle',
            'RC Exploitation',
            'RC Produits livres',
            'RC Apres livraison',
            'Faute professionnelle',
            'Dommages materiels aux tiers',
            'Dommages immateriels',
            'Defense et recours',
        ],
        formules: [
            { nom: 'Profession liberale', desc: 'Pour les independants et professions liberales', tag: 'Essentiel', prix: 'A partir de 75 000 FCFA/an' },
            { nom: 'Entreprise', desc: 'Pour les PME et grandes entreprises', tag: 'Recommande', prix: 'Sur devis personnalise' },
        ],
        avantages: [
            { icon: <FileProtectOutlined />, titre: 'Protection juridique', desc: 'Defense et recours inclus en cas de litige' },
            { icon: <TeamOutlined />, titre: 'Tous secteurs couverts', desc: 'BTP, sante, conseil, commerce, industrie, etc.' },
            { icon: <SafetyCertificateOutlined />, titre: 'Plafonds eleves', desc: 'Des plafonds de garantie adaptes a votre activite' },
            { icon: <DollarOutlined />, titre: 'Primes ajustees', desc: 'Tarification selon votre chiffre d\'affaires reel' },
        ],
        faq: [
            { q: 'La RC professionnelle est-elle obligatoire ?', r: 'Elle est obligatoire pour certaines professions reglementees (BTP, sante, expertise comptable, etc.) et fortement recommandee pour toutes les entreprises.' },
            { q: 'Quel est le plafond de garantie ?', r: 'Le plafond est determine selon votre activite et votre chiffre d\'affaires. Nos conseillers vous aident a definir le bon niveau.' },
            { q: 'Les sous-traitants sont-ils couverts ?', r: 'Oui, la RC Exploitation peut couvrir les dommages causes par vos sous-traitants dans le cadre de votre activite.' },
        ],
        temoignage: { nom: 'Cabinet Diallo & Associes', ville: 'Plateau', texte: 'Notre cabinet de conseil a souscrit une RC Pro chez CAP Assurances. Le service est professionnel et les garanties parfaitement adaptees a notre activite.' },
    },
    plantation: {
        icon: <SafetyOutlined />,
        title: 'Assurance Plantation',
        category: 'Agricole',
        color: '#1b5e20',
        description: 'Protegez vos exploitations agricoles contre les aleas climatiques et les risques naturels. Nos solutions couvrent cacao, cafe, hevea, palmier et plus.',
        accroche: 'Vos plantations sont votre richesse, protegeons-les ensemble.',
        garanties: [
            'Incendie de plantation',
            'Secheresse severe',
            'Inondation',
            'Tempete et ouragan',
            'Maladies des cultures',
            'Perte de recolte',
            'Dommages aux equipements',
            'Responsabilite civile exploitation',
        ],
        formules: [
            { nom: 'Petits exploitants', desc: 'Pour les petites exploitations familiales', tag: 'Essentiel', prix: 'A partir de 100 000 FCFA/an' },
            { nom: 'Grands domaines', desc: 'Pour les grandes exploitations commerciales', tag: 'Recommande', prix: 'Sur devis personnalise' },
        ],
        avantages: [
            { icon: <SafetyCertificateOutlined />, titre: 'Couverture complete', desc: 'Incendie, secheresse, inondation, maladies - tous les risques couverts' },
            { icon: <TeamOutlined />, titre: 'Experts agricoles', desc: 'Des specialistes du monde rural qui comprennent vos besoins' },
            { icon: <DollarOutlined />, titre: 'Indemnisation juste', desc: 'Evaluation precise de vos pertes par des experts terrain' },
            { icon: <ClockCircleOutlined />, titre: 'Intervention rapide', desc: 'Expertise sur site sous 72h apres declaration' },
        ],
        faq: [
            { q: 'Quelles cultures sont couvertes ?', r: 'Cacao, cafe, hevea, palmier a huile, anacarde, et toutes les cultures perennes de Cote d\'Ivoire.' },
            { q: 'Comment est evaluee la valeur de ma plantation ?', r: 'Nos experts se deplacent sur votre exploitation pour evaluer la surface, le type de culture et le rendement attendu.' },
            { q: 'Les equipements agricoles sont-ils couverts ?', r: 'Oui, nos formules incluent la couverture du materiel et des equipements utilises sur l\'exploitation.' },
        ],
        temoignage: { nom: 'Yao K.', ville: 'Soubre', texte: 'Apres l\'incendie de 3 hectares de cacao, CAP Assurances m\'a indemnise en 2 semaines. Sans eux, j\'aurais tout perdu.' },
    },
    recolte: {
        icon: <SafetyOutlined />,
        title: 'Assurance Recolte',
        category: 'Agricole',
        color: '#33691e',
        description: 'Securisez vos revenus agricoles en assurant vos recoltes contre les pertes dues aux conditions meteorologiques et aux catastrophes naturelles.',
        accroche: 'Votre recolte assuree, vos revenus proteges.',
        garanties: [
            'Perte de rendement',
            'Secheresse',
            'Inondation',
            'Grele',
            'Gel',
            'Ravageurs et parasites',
            'Maladies cryptogamiques',
            'Indemnisation rapide',
        ],
        formules: [
            { nom: 'Saisonnier', desc: 'Couverture pour une saison de culture', tag: 'Essentiel', prix: 'A partir de 50 000 FCFA/saison' },
            { nom: 'Annuel', desc: 'Protection tout au long de l\'annee', tag: 'Recommande', prix: 'A partir de 120 000 FCFA/an' },
        ],
        avantages: [
            { icon: <ThunderboltOutlined />, titre: 'Indemnisation express', desc: 'Paiement de votre indemnite sous 15 jours ouvrables' },
            { icon: <SafetyCertificateOutlined />, titre: 'Tous aleas couverts', desc: 'Secheresse, inondation, parasites, maladies - rien n\'est laisse au hasard' },
            { icon: <TeamOutlined />, titre: 'Accompagnement terrain', desc: 'Nos agents se deplacent directement sur vos parcelles' },
            { icon: <DollarOutlined />, titre: 'Prime abordable', desc: 'Des tarifs etudies pour les agriculteurs ivoiriens' },
        ],
        faq: [
            { q: 'A quel moment souscrire ?', r: 'Idealement avant le debut de la saison de culture. Contactez-nous des la preparation de vos parcelles.' },
            { q: 'Comment est calculee l\'indemnite ?', r: 'L\'indemnite est basee sur le rendement moyen de votre parcelle et le prix du marche au moment de la perte.' },
            { q: 'Les cultures vivrieres sont-elles couvertes ?', r: 'Oui, riz, mais, manioc, igname et toutes les cultures vivrieres peuvent etre assurees.' },
        ],
        temoignage: { nom: 'Coulibaly M.', ville: 'Bouake', texte: 'La secheresse a detruit 60% de mon mais cette annee. Grace a CAP Assurances, j\'ai pu replanter la saison suivante.' },
    },
    betail: {
        icon: <BugOutlined />,
        title: 'Assurance Betail',
        category: 'Agricole',
        color: '#4e342e',
        description: 'Protegez votre cheptel contre la mortalite, les maladies et les accidents. L\'assurance betail garantit la perennite de votre elevage.',
        accroche: 'Votre cheptel est votre capital, assurons-le.',
        garanties: [
            'Mortalite accidentelle',
            'Maladies epidemiques',
            'Foudre et electrocution',
            'Empoisonnement',
            'Accidents de transport',
            'Vol de betail',
            'Frais veterinaires',
            'Perte de production',
        ],
        formules: [
            { nom: 'Petit elevage', desc: 'Pour les eleveurs de petits ruminants', tag: 'Essentiel', prix: 'A partir de 30 000 FCFA/an' },
            { nom: 'Gros elevage', desc: 'Pour les bovins et grands troupeaux', tag: 'Recommande', prix: 'Sur devis personnalise' },
        ],
        avantages: [
            { icon: <HeartOutlined />, titre: 'Frais veterinaires inclus', desc: 'Prise en charge des soins pour votre cheptel' },
            { icon: <SafetyCertificateOutlined />, titre: 'Vol et epidemie', desc: 'Couverture contre les risques les plus devastateurs' },
            { icon: <ClockCircleOutlined />, titre: 'Expertise rapide', desc: 'Evaluation de votre sinistre sous 48h sur site' },
            { icon: <DollarOutlined />, titre: 'Valeur de marche', desc: 'Indemnisation basee sur la valeur reelle de vos animaux' },
        ],
        faq: [
            { q: 'Quels animaux peuvent etre assures ?', r: 'Bovins, ovins, caprins, porcins, volailles et tout type d\'elevage pratique en Cote d\'Ivoire.' },
            { q: 'Faut-il un certificat veterinaire ?', r: 'Oui, un certificat de bonne sante delivre par un veterinaire agree est necessaire a la souscription.' },
            { q: 'Le vol de betail est-il couvert ?', r: 'Oui, nos deux formules incluent la couverture contre le vol, sous reserve de depot de plainte.' },
        ],
        temoignage: { nom: 'Soro F.', ville: 'Korhogo', texte: 'J\'ai perdu 15 boeufs suite a une epidemie. CAP Assurances m\'a indemnise a la valeur du marche. Je recommande a tous les eleveurs du Nord.' },
    },
};

// Page catalogue (sans parametre)
function AssurancesCatalogue() {
    const navigate = useNavigate();

    const iardItems = Object.entries(assurancesData).filter(([, v]) => v.category === 'IARD');
    const agricoleItems = Object.entries(assurancesData).filter(([, v]) => v.category === 'Agricole');

    const renderCards = (items) => (
        <Row gutter={[24, 24]}>
            {items.map(([key, item]) => (
                <Col xs={24} sm={12} lg={8} key={key}>
                    <Card hoverable className="catalogue-card" onClick={() => navigate(`/assurances/${key}`)}>
                        <div className="catalogue-icon" style={{ background: item.color }}>{item.icon}</div>
                        <Title level={4}>{item.title}</Title>
                        <Paragraph ellipsis={{ rows: 2 }} className="catalogue-desc">{item.description}</Paragraph>
                        <Button type="link" style={{ padding: 0, color: '#C8102E' }}>
                            Decouvrir <ArrowRightOutlined />
                        </Button>
                    </Card>
                </Col>
            ))}
        </Row>
    );

    return (
        <div className="page-assurances-catalogue">
            <section className="assurances-hero">
                <Title level={1} className="hero-title">Nos Assurances</Title>
                <Paragraph className="hero-subtitle">
                    Decouvrez l'ensemble de nos solutions d'assurances pour particuliers et entreprises
                </Paragraph>
            </section>

            <section className="section">
                <div className="section-inner">
                    <Title level={2}>Assurances IARD</Title>
                    <div className="section-line left" />
                    <Paragraph style={{ marginBottom: 32 }}>
                        Incendie, Accidents et Risques Divers - Protegez vos biens et votre responsabilite
                    </Paragraph>
                    {renderCards(iardItems)}

                    <div style={{ marginTop: 64 }}>
                        <Title level={2}>Risques Agricoles</Title>
                        <div className="section-line left" />
                        <Paragraph style={{ marginBottom: 32 }}>
                            Des solutions adaptees aux professionnels de l'agriculture et de l'elevage
                        </Paragraph>
                        {renderCards(agricoleItems)}
                    </div>
                </div>
            </section>
        </div>
    );
}

// Page detail d'une assurance
function AssuranceDetail() {
    const { type } = useParams();
    const navigate = useNavigate();
    const data = assurancesData[type];

    if (!data) {
        return (
            <div style={{ textAlign: 'center', padding: '120px 24px' }}>
                <Title level={3}>Assurance non trouvee</Title>
                <Button type="primary" onClick={() => navigate('/assurances')}>
                    Voir toutes nos assurances
                </Button>
            </div>
        );
    }

    const stats = [
        { value: '8+', label: 'Compagnies comparees' },
        { value: '24h', label: 'Delai attestation' },
        { value: '98%', label: 'Clients satisfaits' },
        { value: '2', label: 'Agences a Abidjan' },
    ];

    return (
        <div className="page-assurance-detail">
            {/* HERO SECTION */}
            <section className="detail-hero" style={{ background: `linear-gradient(135deg, ${data.color}, ${data.color}dd)` }}>
                <div className="hero-content">
                    <Tag color="#fff" style={{ color: data.color, fontWeight: 600, marginBottom: 12 }}>
                        {data.category}
                    </Tag>
                    <Title level={1} className="hero-title">{data.title}</Title>
                    <Paragraph className="hero-accroche">{data.accroche}</Paragraph>
                    <Paragraph className="hero-subtitle">{data.description}</Paragraph>
                    <Space size={16} wrap>
                        <Button
                            size="large"
                            style={{ background: '#fff', color: data.color, fontWeight: 600, height: 48 }}
                            icon={<PhoneOutlined />}
                            onClick={() => navigate('/contact')}
                        >
                            Demander un devis gratuit
                        </Button>
                        <Button
                            size="large"
                            ghost
                            style={{ borderColor: '#fff', color: '#fff', fontWeight: 600, height: 48 }}
                            icon={<WhatsAppOutlined />}
                            onClick={() => window.open('https://wa.me/22507000000', '_blank')}
                        >
                            Ecrire sur WhatsApp
                        </Button>
                    </Space>
                </div>
            </section>

            {/* CHIFFRES CLES */}
            <section className="stats-band">
                <div className="section-inner">
                    <Row gutter={[24, 24]} justify="center">
                        {stats.map((s, i) => (
                            <Col xs={12} sm={6} key={i} className="stat-item">
                                <div className="stat-value" style={{ color: data.color }}>{s.value}</div>
                                <div className="stat-label">{s.label}</div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* AVANTAGES CAP ASSURANCES */}
            {data.avantages && (
                <section className="section section-avantages">
                    <div className="section-inner">
                        <div style={{ textAlign: 'center', marginBottom: 48 }}>
                            <Title level={2}>Pourquoi choisir CAP Assurances ?</Title>
                            <div className="section-line center" />
                            <Paragraph style={{ fontSize: 16, color: '#666', maxWidth: 600, margin: '0 auto' }}>
                                Nous vous accompagnons pour trouver la meilleure couverture au meilleur prix
                            </Paragraph>
                        </div>
                        <Row gutter={[32, 32]}>
                            {data.avantages.map((a, i) => (
                                <Col xs={24} sm={12} lg={6} key={i}>
                                    <Card className="avantage-card" bordered={false}>
                                        <div className="avantage-icon" style={{ background: `${data.color}15`, color: data.color }}>
                                            {a.icon}
                                        </div>
                                        <Title level={5} style={{ marginTop: 16 }}>{a.titre}</Title>
                                        <Text type="secondary">{a.desc}</Text>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </section>
            )}

            {/* GARANTIES + FORMULES */}
            <section className="section">
                <div className="section-inner">
                    <Row gutter={[48, 48]}>
                        <Col xs={24} lg={14}>
                            <Title level={2}>Garanties incluses</Title>
                            <div className="section-line left" />
                            <Paragraph style={{ marginBottom: 24, color: '#666' }}>
                                Chaque formule inclut un socle de garanties solides pour vous proteger efficacement
                            </Paragraph>
                            <Row gutter={[16, 0]}>
                                {data.garanties.map((g, i) => (
                                    <Col xs={24} sm={12} key={i}>
                                        <div className="garantie-item">
                                            <CheckCircleOutlined style={{ color: data.color, fontSize: 18 }} />
                                            <Text style={{ fontSize: 15 }}>{g}</Text>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>

                        <Col xs={24} lg={10}>
                            <Title level={2}>Nos formules</Title>
                            <div className="section-line left" />
                            <Space direction="vertical" size={16} style={{ width: '100%' }}>
                                {data.formules.map((f, i) => (
                                    <Card key={i} className={`formule-card ${f.tag === 'Recommande' ? 'formule-recommended' : ''}`} size="small"
                                        style={f.tag === 'Recommande' ? { borderColor: data.color, borderWidth: 2 } : {}}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                                            <Title level={5} style={{ margin: 0 }}>{f.nom}</Title>
                                            <Tag color={f.tag === 'Premium' ? 'gold' : f.tag === 'Recommande' ? 'blue' : f.tag === 'Entreprise' ? 'purple' : 'default'}>
                                                {f.tag}
                                            </Tag>
                                        </div>
                                        <Text type="secondary">{f.desc}</Text>
                                        {f.prix && (
                                            <div style={{ marginTop: 8 }}>
                                                <Text strong style={{ color: data.color, fontSize: 13 }}>{f.prix}</Text>
                                            </div>
                                        )}
                                    </Card>
                                ))}
                            </Space>

                            <Card className="devis-card" style={{ marginTop: 24, background: `linear-gradient(135deg, ${data.color}, ${data.color}dd)`, border: 'none' }}>
                                <Title level={4} style={{ color: '#fff', marginBottom: 4 }}>Obtenez votre devis gratuit</Title>
                                <Paragraph style={{ color: 'rgba(255,255,255,0.85)', marginBottom: 16 }}>
                                    Sans engagement - Reponse sous 24h
                                </Paragraph>
                                <Button
                                    block
                                    size="large"
                                    style={{ background: '#fff', color: data.color, fontWeight: 600, height: 48 }}
                                    onClick={() => navigate('/contact')}
                                >
                                    Nous contacter maintenant
                                </Button>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* TEMOIGNAGE CLIENT */}
            {data.temoignage && (
                <section className="section section-temoignage" style={{ background: '#f7f8fa' }}>
                    <div className="section-inner" style={{ maxWidth: 800 }}>
                        <div style={{ textAlign: 'center', marginBottom: 32 }}>
                            <Title level={2}>Ce que disent nos clients</Title>
                            <div className="section-line center" />
                        </div>
                        <Card className="temoignage-card" bordered={false}>
                            <div className="temoignage-stars">
                                {[1,2,3,4,5].map(s => <StarFilled key={s} style={{ color: '#fadb14', fontSize: 20 }} />)}
                            </div>
                            <Paragraph className="temoignage-texte">
                                "{data.temoignage.texte}"
                            </Paragraph>
                            <div className="temoignage-auteur">
                                <div className="temoignage-avatar" style={{ background: data.color }}>
                                    {data.temoignage.nom.charAt(0)}
                                </div>
                                <div>
                                    <Text strong>{data.temoignage.nom}</Text>
                                    <br />
                                    <Text type="secondary">{data.temoignage.ville}</Text>
                                </div>
                            </div>
                        </Card>
                    </div>
                </section>
            )}

            {/* FAQ */}
            {data.faq && (
                <section className="section section-faq">
                    <div className="section-inner" style={{ maxWidth: 800 }}>
                        <div style={{ textAlign: 'center', marginBottom: 48 }}>
                            <Title level={2}>Questions frequentes</Title>
                            <div className="section-line center" />
                        </div>
                        <Space direction="vertical" size={16} style={{ width: '100%' }}>
                            {data.faq.map((item, i) => (
                                <Card key={i} className="faq-card" size="small">
                                    <Title level={5} style={{ marginBottom: 8, color: data.color }}>{item.q}</Title>
                                    <Text type="secondary" style={{ fontSize: 14, lineHeight: 1.7 }}>{item.r}</Text>
                                </Card>
                            ))}
                        </Space>
                    </div>
                </section>
            )}

            {/* CTA FINAL */}
            <section className="section-cta-final" style={{ background: `linear-gradient(135deg, ${data.color}, ${data.color}dd)` }}>
                <div className="section-inner" style={{ textAlign: 'center' }}>
                    <TrophyOutlined style={{ fontSize: 48, color: 'rgba(255,255,255,0.9)', marginBottom: 16 }} />
                    <Title level={2} style={{ color: '#fff', marginBottom: 8 }}>Pret a vous assurer ?</Title>
                    <Paragraph style={{ color: 'rgba(255,255,255,0.9)', fontSize: 17, maxWidth: 500, margin: '0 auto 32px' }}>
                        Obtenez votre devis personnalise en quelques minutes. C'est gratuit et sans engagement.
                    </Paragraph>
                    <Space size={16} wrap style={{ justifyContent: 'center' }}>
                        <Button
                            size="large"
                            style={{ background: '#fff', color: data.color, fontWeight: 700, height: 52, fontSize: 16, paddingInline: 32 }}
                            icon={<PhoneOutlined />}
                            onClick={() => navigate('/contact')}
                        >
                            Demander un devis gratuit
                        </Button>
                        <Button
                            size="large"
                            ghost
                            style={{ borderColor: '#fff', color: '#fff', fontWeight: 600, height: 52, fontSize: 16, paddingInline: 32 }}
                            icon={<PhoneOutlined />}
                            onClick={() => window.open('tel:+22507000000')}
                        >
                            Appeler maintenant
                        </Button>
                    </Space>
                    <Paragraph style={{ color: 'rgba(255,255,255,0.7)', marginTop: 24, fontSize: 13 }}>
                        Disponible du lundi au vendredi, de 8h00 a 17h30
                    </Paragraph>
                </div>
            </section>
        </div>
    );
}

export default function Assurances() {
    const { type } = useParams();
    return type ? <AssuranceDetail /> : <AssurancesCatalogue />;
}
